import { getAssetPath } from '@stencil/core';

import { PUBLIC_BASE_URL } from '../../config/constants';

/**
 * Resize image from a given image file.
 *
 * @param {HTMLImageElement} image - The HTML image element
 * @param {File} file - The original image file
 * @return The string representation of the image file already resized up to 1280px.
 */
export function resizeImageFromFile(image: HTMLImageElement, file: File) {
  const maxSize = 1280;
  let h = image.height;
  let w = image.width;

  if (w > h) {
    if (w > maxSize) {
      h *= maxSize / w;
      w = maxSize;
    }
  } else {
    if (h > maxSize) {
      w *= maxSize / h;
      h = maxSize;
    }
  }

  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;

  canvas.getContext('2d').drawImage(image, 0, 0, w, h);
  // return dataURL
  return file.type === 'image/jpeg' ? canvas.toDataURL('image/jpeg', 1.0) : canvas.toDataURL('image/png');
}

/**
 * Get an image absolute URL from its relative path
 *
 * @param path the image relative path
 * @returns the image public absolute URL
 */
export const getAbsoluteAssetPath = (path: string): string => {
  if (!path || path.startsWith('http')) return path;

  if (process.env.NODE_ENV === 'production' && PUBLIC_BASE_URL.startsWith('http')) {
    return new URL(path.toLowerCase(), `${PUBLIC_BASE_URL}panenka/`).href;
  }

  return getAssetPath(path.toLowerCase());
};

export const parseSvgString = (src: string) => {
  if (!src?.includes('xmlns')) return null;

  // convert the string to a blob
  const _svgElem = new Blob([src], { type: 'image/svg+xml' });
  // create a URL to the blob
  return URL.createObjectURL(_svgElem);
};
